import React, { useMemo } from 'react'
import cn from 'classnames'
import ReactTableStatistics from '@sportninja/common/components/ReactTableStatistics'

import { Mobile } from '../Responsive'
import StatisticsWrapper, {
  DEFAULT_COL_WIDTH,
  DEFAULT_COL_WIDTH_MOBILE,
} from './StatisticsWrapper'
import StatisticsRenderer from './StatisticsRenderer'

// We declare a separate component here for use in Statistics, so it isn't redeclared
// every render
const StatisticsComponent = ({ isMobile, ...props }) => {
  return (
    <StatisticsWrapper className={cn({ mobile: isMobile })}>
      <StatisticsRenderer isMobile={isMobile} {...props} />
    </StatisticsWrapper>
  )
}

// We need a declared functional component to be able to use React hooks
const StatisticsTableSetup = ({ columns: _columns, isMobile, ...props }) => {
  const { columns, totalWidth } = useMemo(() => {
    // react-table wants a deterministic width set, so it can apply a width style
    // to each row. we need this to be accurate so that our sticky column works
    // properly.
    let totalWidth = 0
    const columns = _columns.map((column, idx) => {
      if (idx === 0) {
        totalWidth += isMobile ? 120 : 200
      } else {
        totalWidth += 54
      }
      const width = isMobile ? column.mobileWidth : column.width
      // totalWidth += width
      return { ...column, width }
    })

    return { columns, totalWidth }
  }, [_columns, isMobile])

  const defaultColumn = useMemo(
    () => ({
      width: isMobile ? DEFAULT_COL_WIDTH_MOBILE : DEFAULT_COL_WIDTH,
    }),
    []
  )

  return (
    <ReactTableStatistics
      columns={columns}
      defaultColumn={defaultColumn}
      isMobile={isMobile}
      component={StatisticsComponent}
      totalWidth={totalWidth}
      {...props}
    />
  )
}

const StatisticsTable = (props) => {
  return (
    <Mobile>
      {(isMobile) => {
        return <StatisticsTableSetup isMobile={isMobile} {...props} />
      }}
    </Mobile>
  )
}

export default StatisticsTable
